import styled, { css } from 'styled-components';
import {
  Modal as DefaultModal,
  Title,
  Button as BaseButton,
} from '@getinapp/appetizer';

export const Subtitle = styled.h2`
  font-family: 'Adobe Caslon';
  font-style: italic;

  ${({ theme }) => css`
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.medium};
    line-height: ${theme.font.sizes.large};
    color: ${theme.colors.highContrast};
  `}
`;

export const Modal = styled(DefaultModal)`
  background: white;
  width: 100%;
  min-width: auto !important;
  max-width: 37.3rem;
`;

export const TitleModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleModal = styled(Title)`
  font-size: 1.8rem;
  line-height: 140%;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 2.4rem;

  ${({ theme }) => css`
    > p.description {
      font-size: ${theme.font.sizes.medium};
      line-height: 160%;
      color: ${theme.colors.highContrast};
    }
  `}
`;

export const Button = styled(BaseButton)`
  width: 100%;

  div.content {
    display: flex;
    align-items: center;
    gap: 1.6rem;
  }
`;
